// 首頁開頭的「現況」（ls-loop 2026-10-11 外觀翻新，John 定 A / B 兩套外觀可切）：
//  - A 監控室：三個大數字（在線、需要處理、最近事件）
//  - B 居家：一句白話講現況 + 最近一次發生什麼
// 兩種都畫進 DOM，CSS 依 <html data-look> 只顯示一種（global.css），不用另外訂閱外觀變化。
import { useTranslation } from 'react-i18next';
import { clusterOf } from '../events/eventsLib';
import { cameraClass, deviceName, tileState, type DeviceSummary } from '../devices/deviceModel';

function hhmm(us: number): string {
  const d = new Date(us / 1000);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function HomeHero({ devices }: { devices: DeviceSummary[] }) {
  const { t } = useTranslation();
  const cams = devices.filter((d) => cameraClass(d) === 'camera');
  const online = cams.filter((d) => tileState(d) === 'online').length;
  const attention = cams.length - online;
  let last: { d: DeviceSummary; ts: number; id: string } | null = null;
  for (const d of cams) {
    const ts = d.last_event?.event_ts ?? 0;
    if (ts > 0 && (!last || ts > last.ts)) last = { d, ts, id: d.last_event?.event_id ?? d.last_event?.event_type ?? '' };
  }
  const kind = last ? clusterOf(last.id).label : '';

  return (
    <section className="home-hero" aria-label={t('home.heroLabel')} data-testid="home-hero">
      <div className="home-hero-control">
        <div className="home-hero-stat">
          <span className="home-hero-num">
            {online}
            <span className="home-hero-of">/{cams.length}</span>
          </span>
          <span className="home-hero-cap">{t('home.heroOnline')}</span>
        </div>
        <div className={`home-hero-stat${attention > 0 ? ' home-hero-alert' : ''}`}>
          <span className="home-hero-num">{attention}</span>
          <span className="home-hero-cap">{t('home.heroAttention')}</span>
        </div>
        <div className="home-hero-stat">
          <span className="home-hero-num">{last ? hhmm(last.ts) : '—'}</span>
          <span className="home-hero-cap">{last ? t('home.heroLatestOf', { kind, cam: deviceName(last.d) }) : t('home.heroNoEvent')}</span>
        </div>
      </div>
      <div className="home-hero-home">
        <p className="home-hero-sentence">
          {attention === 0 ? t('home.heroCalm', { count: cams.length }) : t('home.heroOffline', { count: attention })}
        </p>
        <p className="home-hero-sub">
          {last ? t('home.heroLast', { time: hhmm(last.ts), cam: deviceName(last.d), kind }) : t('home.heroNoEvent')}
        </p>
      </div>
    </section>
  );
}
